var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lesson-extra-technical-drawing d-flex flex-column",staticStyle:{"height":"100%"}},[_c('technical-drawing',{attrs:{"title":_vm.title,"figures":_vm.figures,"assets":_vm.data}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }